import { useGeoMarkupStore } from '@/store';
import { selectShouldHideUIOnMobile } from '@/store/selectors';

import { useDeviceLayout } from './useDeviceLayout';

/**
 * Single source of truth for the "hide floating map chrome on mobile" guard.
 *
 * True when the viewport is mobile AND a SlidePanel (artifact form/details,
 * layers, configurator, public share detail, …) is open and fully expanded —
 * meaning floating overlays (toolbar, search, layers panel, floating controls)
 * would be covered and should be hidden.
 *
 * Reused by AppShell, MapControls, MapToolbox, MapContainer,
 * DrawingInstructions, and the public share map (PublicMapShell /
 * SharedMapPage) so the guard logic lives in exactly one place.
 */
export function useHideMobileChrome(): boolean {
  const { isMobile } = useDeviceLayout();
  const shouldHideUI = useGeoMarkupStore(selectShouldHideUIOnMobile);
  return isMobile && shouldHideUI;
}
